export enum ResourceStatus {
  Idle = 'Resource Idle',
  InProgress = 'Resource Retrieval in Progress',
  Failure = 'Resource Retrieval Failed',
  Success = 'Resource Retrieval Succeeded',
}
